import { render } from "./Items.vue?vue&type=template&id=535c568c&ts=true"
import script from "./Items.vue?vue&type=script&lang=ts"
export * from "./Items.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__